import { JSONSchema7 } from 'json-schema';
import * as yup from 'yup';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';

export default (
  control: ControlState
): {
  [key: string]: yup.AnySchema;
} => {
  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const requiredSchema = properties['required'] as JSONSchema7;
  const minimumDateSchema = properties['minimumDate'] as JSONSchema7;
  const maximumDateSchema = properties['maximumDate'] as JSONSchema7;

  let controlYupSchema = yup
    .date()
    .transform((_, val) => (val ? new Date(val) : null))
    .typeError('Date must be MM/DD/YYYY')
    .nullable(true);

  if (!control.visible) {
    return {
      [control.id]: controlYupSchema
    };
  }

  if (requiredSchema && requiredSchema.default) {
    controlYupSchema = controlYupSchema.required(
      `${labelSchema.default} is required`
    );
  }

  if (minimumDateSchema) {
    const min = new Date(minimumDateSchema.default as string);
    controlYupSchema = controlYupSchema.min(
      min,
      `${
        labelSchema.default
      } must be greater than or equal to ${min.toLocaleDateString()}`
    );
  }

  if (maximumDateSchema) {
    const max = new Date(maximumDateSchema.default as string);
    controlYupSchema = controlYupSchema.max(
      max,
      `${
        labelSchema.default
      } must be less than or equal to ${max.toLocaleDateString()}`
    );
  }

  return {
    [control.id]: controlYupSchema
  };
};
